import * as actions from "../actions/session";
import { addUniqueSafe, deleteOrNop, removeValue, setSafe, } from "../util/storeHelper";
import * as path from "path";
export function makeExeId(exePath) {
    // TODO: stripping the path means that we can't distinguish between different installations
    // of the same exe running at the same time, we might see an exe as "not running" when it
    // actually is. This is rather unlikely though.
    // On the flipside, if we _don't_ use the basename, lookup will be more complicated and
    // thus slower.
    return path.basename(exePath).toLowerCase();
}
/**
 * reducer for changes to the window state
 */
export const sessionReducer = {
    reducers: {
        [actions.displayGroup]: (state, payload) => setSafe(state, ["displayGroups", payload.groupId], payload.itemId),
        [actions.setDialogVisible]: (state, payload) => setSafe(state, ["visibleDialog"], payload.dialogId),
        [actions.setSettingsPage]: (state, payload) => setSafe(state, ["settingsPage"], payload.pageId),
        [actions.startActivity]: (state, payload) => addUniqueSafe(state, ["activity", payload.group], payload.activityId),
        [actions.stopActivity]: (state, payload) => removeValue(state, ["activity", payload.group], payload.activityId),
        [actions.setProgress]: (state, payload) => setSafe(state, ["progress", payload.group, payload.progressId], {
            text: payload.text,
            percent: Math.round(payload.percent),
        }),
        [actions.setOpenMainPage]: (state, payload) => {
            if (payload.secondary) {
                return setSafe(state, ["secondaryPage"], payload.page);
            }
            else {
                return setSafe(setSafe(state, ["mainPage"], payload.page), ["secondaryPage"], "");
            }
        },
        [actions.setExtensionLoadFailures]: (state, payload) => setSafe(state, ["extLoadFailures"], payload),
        [actions.setToolRunning]: (state, payload) => setSafe(state, ["toolsRunning", makeExeId(payload.exePath)], {
            exePath: payload.exePath,
            started: payload.started,
            pid: undefined,
            exclusive: payload.exclusive || false,
        }),
        [actions.setToolPid]: (state, payload) => setSafe(state, ["toolsRunning", makeExeId(payload.exePath)], {
            exePath: payload.exePath,
            started: payload.started,
            pid: payload.pid,
            exclusive: payload.exclusive || false,
        }),
        [actions.setToolStopped]: (state, payload) => deleteOrNop(state, ["toolsRunning", makeExeId(payload.exePath)]),
        [actions.setUIBlocker]: (state, payload) => setSafe(state, ["uiBlockers", payload.id], {
            icon: payload.icon,
            description: payload.description,
            mayCancel: payload.mayCancel,
        }),
        [actions.clearUIBlocker]: (state, payload) => deleteOrNop(state, ["uiBlockers", payload]),
        [actions.setNetworkConnected]: (state, payload) => setSafe(state, ["networkConnected"], payload),
        [actions.setCommandLine]: (state, payload) => setSafe(state, ["commandLine"], payload),
        [actions.setDownloadGameFilter]: (state, payload) => setSafe(state, ["downloadGameFilter"], payload),
    },
    defaults: {
        displayGroups: {},
        visibleDialog: undefined,
        overlayOpen: false,
        networkConnected: true,
        mainPage: "",
        secondaryPage: "",
        activity: {},
        progress: {},
        settingsPage: undefined,
        extLoadFailures: {},
        toolsRunning: {},
        uiBlockers: {},
        commandLine: {},
        downloadGameFilter: null,
    },
};
